var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcWalletBook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 2.0835H4.91699C3.81242 2.0835 2.91699 2.97893 2.91699 4.0835V15.0002M5.83366 2.0835V10.0002L6.888 9.36756C7.52137 8.98754 8.31262 8.98754 8.94598 9.36756L10.0003 10.0002V2.0835M5.83366 2.0835H10.0003M10.0003 2.0835H15.0837C16.1882 2.0835 17.0837 2.97893 17.0837 4.0835V15.0002M2.91699 15.0002V15.9168C2.91699 17.0214 3.81242 17.9168 4.91699 17.9168H15.0837C16.1882 17.9168 17.0837 17.0214 17.0837 15.9168V15.0002M2.91699 15.0002H17.0837",
    stroke: "#36382E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcWalletBook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_wallet_book.9acf47d3f2910497833a11784c81ba5b.svg";